<script lang="ts">
	import { createEventDispatcher } from 'svelte';

	export let subtitle: string;

	const dispatch = createEventDispatcher();
</script>

<button on:click={() => dispatch('showOverlay')}>
	<div class="flex flex-col jusftiy-center items-center">
		<slot />
		<div class="text-lg -mt-2">{subtitle}</div>
	</div>
</button>
